// Date helpers ported from the prototype's data.js.
// Dates in the app are always YYYY-MM-DD ISO strings (no times for dates).

export const parseDate = (s: string): Date => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const today = (): Date => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

export const daysFromToday = (s: string): number => {
  const diff = parseDate(s).getTime() - today().getTime();
  return Math.round(diff / (1000 * 60 * 60 * 24));
};

export const dayDiff = (a: Date, b: Date): number =>
  Math.round((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const fmtShort = (d: Date | string): string => {
  const dt = typeof d === 'string' ? parseDate(d) : d;
  return `${MONTHS[dt.getMonth()]} ${dt.getDate()}`;
};

export const fmtRange = (startS: string, endS: string): string =>
  `${fmtShort(startS)} — ${fmtShort(endS)}`;

export const fmtRelative = (s: string): string => {
  const d = daysFromToday(s);
  if (d === 0) return 'today';
  if (d === 1) return 'in 1d';
  if (d === -1) return 'yesterday';
  if (d > 0 && d < 14) return `in ${d}d`;
  if (d < 0 && d > -14) return `${Math.abs(d)}d ago`;
  return fmtShort(s);
};

export const toISODate = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
